import { render } from "./DianYuan.vue?vue&type=template&id=ec5c14de&scoped=true"
import script from "./DianYuan.vue?vue&type=script&lang=js"
export * from "./DianYuan.vue?vue&type=script&lang=js"

import "./DianYuan.vue?vue&type=style&index=0&id=ec5c14de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec5c14de"]])

export default __exports__